const getDocumentTop = (element) => {
  let top = 0;
  let currentElement = element;

  while (currentElement) {
    top += currentElement.offsetTop;
    currentElement = currentElement.offsetParent;
  }

  return top;
};

export default function initDestinationCategories() {
  const categoryNav = document.querySelector('[data-destination-categories]');

  if (!categoryNav) {
    return;
  }

  const stickyDistance = Number.parseInt(categoryNav.dataset.stickyDistance, 10) || 300;
  let stickyEnd = 0;
  let frameRequested = false;

  const refreshMetrics = () => {
    const stickyTop = Number.parseFloat(window.getComputedStyle(categoryNav).top) || 0;
    stickyEnd = getDocumentTop(categoryNav) - stickyTop + stickyDistance;
  };

  const updateVisibility = () => {
    categoryNav.classList.toggle('is-past-sticky-range', window.scrollY > stickyEnd);
    frameRequested = false;
  };

  const requestVisibilityUpdate = () => {
    if (frameRequested) {
      return;
    }

    frameRequested = true;
    window.requestAnimationFrame(updateVisibility);
  };

  const refresh = () => {
    refreshMetrics();
    requestVisibilityUpdate();
  };

  refresh();
  window.addEventListener('load', refresh, { once: true });
  window.addEventListener('resize', refresh);
  window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
}
